module.exports = __webpack_public_path__ + "img/bannerBook.b188763d.png";